"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatKeys = exports.remap = void 0;
const isMac = /mac/i.test(navigator.platform) || /macintosh/i.test(navigator.userAgent);
const separator = isMac ? ' ' : '+';
exports.remap = {
    Primary: isMac ? '⌘' : 'Ctrl',
    Shift: isMac ? '⇧' : 'Shift',
    Alt: isMac ? '⌥' : 'Alt',
    Ctrl: isMac ? '⌃' : 'Ctrl',
};
const formatKeys = (keys) => {
    let str = '';
    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        key = exports.remap[key] ?? key;
        if (key.length === 1)
            key = key.toUpperCase();
        str += (str ? separator : '') + key;
    }
    return str;
};
exports.formatKeys = formatKeys;
